import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-show-error',
  templateUrl: './show-error.component.html',
  styleUrls: ['./show-error.component.scss']
})
export class ShowErrorComponent implements OnInit {
  @Input() errors: any | null;
  @Input() key: string;

  constructor() {
  }

  ngOnInit() {
  }

}
